import afterEach from '@/router/after-each'
import beforeEach from '@/router/before-each'
import Vue from 'vue'
import VueRouter from 'vue-router'

import '@/style/nprogress.scss'
import NProgress from 'nprogress'
import parse from 'url-parse'
import common from './modules/common'
import H5 from './modules/h5'
import videoClip from './modules/video-clip/index'

NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})
Vue.use(VueRouter)

export const routes = [...common, ...videoClip, ...H5]

const router = new VueRouter({
  mode: 'history',
  base: '/qiepian/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      const position = {}
      if (to.hash) {
        position.selector = to.hash
      }
      if (to.matched.some((m) => m.meta.scrollToTop)) {
        position.x = 0
        position.y = 0
      }
      return position
    }
  }
})

router.beforeEach(beforeEach)

router.afterEach(afterEach)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch((err) => err)
}

router.__proto__.openWindow = function (obj) {
  const routeData = router.resolve(obj)
  window.open(routeData.href, '_blank')
}

router.__proto__.getAbsolutePath = function (obj) {
  const { href } = router.resolve(obj)
  const { origin } = parse(window.location.href, true)
  return `${origin}${href}`
}

export default router
